import { DuplicateResolutions } from './../../model/duplicate-resolutions';
import { AuthService } from './../../../auth/service/auth.service';
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, map } from 'rxjs';
import { StudentDeduplicationService } from '../../service/student-deduplication.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { DuplicateResolutionStudents } from '../../model/duplicate-resolution-students';
import { TitleCasePipe } from '@angular/common';
import { Region } from 'src/app/model/region.model';
import { LOGINDETAILS } from 'src/app/component/system/accounts/model/login-audit';
import { DuplicateResolutionStudentStatuses } from '../../model/duplicate-resolution-student-statuses';
import { DuplicateResolutionStudentRegions } from '../../model/duplicate-resolution-student-regions';
import { DuplicateResolutionTypes } from '../../model/duplicate-resolution-types';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { AccessService } from 'src/app/component/navigation/service/access.service';

@Component({
    selector: 'children-deduplication-unresolved',
    templateUrl: './children-deduplication-unresolved.component.html',
    styleUrls: ['./children-deduplication-unresolved.component.scss']
})
export class ChildrenDeduplicationUnresolvedComponent {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChild('res') resElement: ElementRef;

    isLoading: boolean = false;
    regionCode: string;
    myRegion: Region;
    user: LOGINDETAILS;
    filter: string;

    // Table display
    columns = {
        EDIT: { INDEX: 1, ENABLED: true, SORT: 'EDIT', DATA: 'EDIT', DISABLED: false },

        Region: {
            INDEX: 2,
            ENABLED: true,
            SORT: 'DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE',
            DATA: 'DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE',
            DISABLED: false
        },

        Status: {
            INDEX: 3,
            ENABLED: true,
            SORT: 'DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS',
            DATA: 'DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS',
            DISABLED: false
        },

        'MSD #': { INDEX: 4, ENABLED: true, SORT: 'STUDENT.MSD_NUMBER', DATA: 'STUDENT.MSD_NUMBER', DISABLED: false },

        Name: { INDEX: 5, ENABLED: true, SORT: 'STUDENT.PERSON.LAST_NAME', DATA: 'STUDENT.PERSON.LAST_NAME', DISABLED: false },

        DOB: { INDEX: 6, ENABLED: true, SORT: 'STUDENT.DOB', DATA: 'STUDENT.DOB', DISABLED: false },

        MB: { INDEX: 7, ENABLED: true, SORT: 'STUDENT.MULTI_BIRTH', DATA: 'STUDENT.MULTI_BIRTH', DISABLED: false },

        BV: { INDEX: 8, ENABLED: true, SORT: 'STUDENT.BIRTH_VERIFY', DATA: 'STUDENT.BIRTH_VERIFY', DISABLED: false },

        'Birth City': { INDEX: 9, ENABLED: true, SORT: 'STUDENT.BIRTH_CITY', DATA: 'STUDENT.BIRTH_CITY', DISABLED: false },

        Gender: { INDEX: 10, ENABLED: true, SORT: 'STUDENT.SEX', DATA: 'STUDENT.SEX', DISABLED: false },

        Mother: { INDEX: 11, ENABLED: true, SORT: 'STUDENT.LEGAL_MOTHERS[0].FIRST_NAME', DATA: 'STUDENT.LEGAL_MOTHERS[0].FIRST_NAME', DISABLED: false },

        Father: { INDEX: 12, ENABLED: true, SORT: 'STUDENT.LEGAL_FATHERS[0].FIRST_NAME', DATA: 'STUDENT.LEGAL_FATHERS[0].FIRST_NAME', DISABLED: false },

        Reason: {
            INDEX: 13,
            ENABLED: true,
            SORT: 'DUPLICATE_RESOLUTION_STUDENT_PROPERTIES[0].DUPLICATE_RESOLUTION_STUDENT_PROPERTY_TYPES.TYPE',
            DATA: 'DUPLICATE_RESOLUTION_STUDENT_PROPERTIES[0].DUPLICATE_RESOLUTION_STUDENT_PROPERTY_TYPES.TYPE',
            DISABLED: false
        }
    };
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    duplicateResolutionsDataSource: MatTableDataSource<DuplicateResolutions>;
    duplicateResolutionStudentsDataSources: MatTableDataSource<DuplicateResolutionStudents>[] = [];

    duplicateResolutions: DuplicateResolutions[];
    duplicateResolutionsSlice: DuplicateResolutions[];
    pageSize: number = 5;

    duplicateResolutionStudentStatuses: DuplicateResolutionStudentStatuses[];
    duplicateResolutionTypes: DuplicateResolutionTypes[];

    routeMsg: MsgModel;

    promises: Array<any> = [];

    titlecasePipe: TitleCasePipe = new TitleCasePipe();

    constructor(
        private route: ActivatedRoute,
        public studentDeduplicationService: StudentDeduplicationService,
        public userProfileService: UserProfileService,
        public authService: AuthService,
        public accessService: AccessService
    ) {
        const regionCode: Observable<string> = route.params.pipe(map((p) => p['regionCode']));
        regionCode.subscribe((x) => {
            this.regionCode = x;
        });
    }

    ngOnInit(): void {
        this.isLoading = true;

        // Permissions
        this.matchUserRegion();

        Promise.all(this.promises).then((hasPermission) => {
            if (hasPermission && hasPermission[0]) {
                this.promises = [];
                this.getUnresolvedDuplicatesByRegion();
                this.indexDuplicateResolutionTypes();
                this.indexDuplicateResolutionStudentStatuses();

                // Display columns
                this.displayedColumns = this.generateDisplayColumns();

                // Display columns
                //this.displayedColumns = this.generateDisplayColumns();

                Promise.all(this.promises).then((res) => {
                    if (this.duplicateResolutions && this.duplicateResolutions.length > 0) {
                        this.updateDuplicateResolutionsDataSource();
                        this.duplicateResolutionsSlice = this.duplicateResolutionsDataSource.data.slice(0, this.pageSize);
                        this.updateDuplicateResolutionStudentsDataSource();
                    }

                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        });
    }

    matchUserRegion() {
        let deferred = new Promise((resolve, reject) => {
            this.routeMsg = new MsgModel();

            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res.user) {
                    this.user = res.user;

                    this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
                        if (res.regions) {
                            this.myRegion = res.regions[0];
                            let features = ['Edit All Duplicate Students'];
                            this.accessService.getFeatureAccessPromise(features).then((res) => {
                                if (res['Edit All Duplicate Students']) {
                                    this.routeMsg.MSG = 'Has permission for all regions';
                                    this.routeMsg.SUCCESS = true;
                                    resolve(true);
                                } else {
                                    if (this.myRegion.CODE === this.regionCode) {
                                        this.routeMsg.MSG = 'Matched';
                                        this.routeMsg.SUCCESS = true;
                                        resolve(true);
                                    } else {
                                        this.routeMsg.MSG = 'You do not have permission to access Region ' + this.regionCode;
                                        this.routeMsg.SUCCESS = false;
                                        resolve(false);
                                    }
                                }
                            });
                        } else {
                            this.routeMsg.MSG = "Unable to retrieve user's Region";
                            this.routeMsg.SUCCESS = false;
                            resolve(false);
                        }
                    });
                } else if (res?.msg) {
                    this.routeMsg.MSG = "Unable to retrieve user's Region";
                    this.routeMsg.SUCCESS = false;
                    resolve(false);
                } else {
                    this.routeMsg.MSG = "Unable to retrieve user's Region";
                    this.routeMsg.SUCCESS = false;
                    resolve(false);
                }
            });
        });
        this.promises.push(deferred);
    }

    generateDisplayColumns(prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    getUnresolvedDuplicatesByRegion() {
        let deferred = new Promise((resolve, reject) => {
            this.studentDeduplicationService.getUnresolvedDuplicatesByRegion(this.regionCode).subscribe((res) => {
                if (res.duplicateResolutions) {
                    this.duplicateResolutions = JSON.parse(res.duplicateResolutions);

                    this.duplicateResolutions.forEach((duplicateResolution) => {
                        this.updateCanResolve(duplicateResolution);
                    });

                    resolve(res);
                } else if (res?.msg) {
                    this.duplicateResolutions = [];
                    resolve(res);
                } else {
                    this.duplicateResolutions = [];
                    resolve('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    indexDuplicateResolutionTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentDeduplicationService.indexDuplicateResolutionTypes().subscribe((res) => {
                if (res.duplicateResolutionTypes) {
                    this.duplicateResolutionTypes = res.duplicateResolutionTypes;

                    resolve(res);
                } else if (res?.msg) {
                    this.duplicateResolutionTypes = [];
                    resolve(res);
                } else {
                    this.duplicateResolutionTypes = [];
                    resolve('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    indexDuplicateResolutionStudentStatuses() {
        let deferred = new Promise((resolve, reject) => {
            this.studentDeduplicationService.indexDuplicateResolutionStudentStatuses().subscribe((res) => {
                if (res.duplicateResolutionStudentStatuses) {
                    this.duplicateResolutionStudentStatuses = res.duplicateResolutionStudentStatuses;

                    resolve(res);
                } else if (res?.msg) {
                    this.duplicateResolutionStudentStatuses = [];
                    resolve(res);
                } else {
                    this.duplicateResolutionStudentStatuses = [];
                    resolve('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    updateDuplicateResolutionsDataSource() {
        // Data
        this.duplicateResolutionsDataSource = new MatTableDataSource<DuplicateResolutions>();
        this.duplicateResolutionsDataSource.data = this.duplicateResolutions;

        // Filter
        this.duplicateResolutionsDataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
        };
    }

    setFilter() {
        this.duplicateResolutionsDataSource.filter = this.filter.trim().toLocaleLowerCase();

        this.duplicateResolutionsSlice = this.duplicateResolutionsDataSource.filteredData.slice(0, this.pageSize);
        this.updateDuplicateResolutionStudentsDataSource();

        this.paginators.toArray()[0].firstPage();
    }

    updateDuplicateResolutionStudentsDataSource() {
        this.duplicateResolutionStudentsDataSources = [];

        // Data
        this.duplicateResolutionsSlice.forEach((drs) => {
            let dataSource = new MatTableDataSource<DuplicateResolutionStudents>();
            let duplicateResolutionStudents: DuplicateResolutionStudents[] = [];

            drs.DUPLICATE_RESOLUTION_STUDENTS.forEach((drs) => {
                let name: string = '';
                name += drs.STUDENT.PERSON.LAST_NAME;
                name += drs.STUDENT.SECOND_LAST_NAME ? ' ' + drs.STUDENT.SECOND_LAST_NAME : '';
                name += ', ' + drs.STUDENT.PERSON.FIRST_NAME;
                name += drs.STUDENT.PERSON.MIDDLE_INITIAL ? ' ' + drs.STUDENT.PERSON.MIDDLE_INITIAL : '';

                name = this.titlecasePipe.transform(name);

                drs.STUDENT.NAME = name;

                drs.DUPLICATE_RESOLUTION_STUDENT_REGIONS.forEach((drsr) => {
                    let newDrs = new DuplicateResolutionStudents();
                    newDrs.ID = drs.ID;
                    newDrs.STUDENT = drs.STUDENT;
                    newDrs.STUDENTS_ID = drs.STUDENTS_ID;
                    newDrs.DUPLICATE_RESOLUTION_STUDENT_PROPERTIES = drs.DUPLICATE_RESOLUTION_STUDENT_PROPERTIES;
                    newDrs.DUPLICATE_RESOLUTION_STUDENT_REGIONS = [];
                    newDrs.DUPLICATE_RESOLUTION_STUDENT_REGIONS.push(drsr);

                    duplicateResolutionStudents.push(newDrs);
                });
            });

            dataSource.data = duplicateResolutionStudents; //.sort((n1: DuplicateResolutionStudents, n2: DuplicateResolutionStudents) => n1.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE! > n2.DUPLICATE_RESOLUTION_STUDENT_REGIONS[0].REGION.CODE! ? 1 : -1);

            this.duplicateResolutionStudentsDataSources.push(dataSource);
        });
    }

    onPageChange(event: PageEvent) {
        let startIndex = event.pageIndex * event.pageSize;
        let endIndex = startIndex + event.pageSize;
        if (endIndex > this.duplicateResolutionsDataSource.filteredData.length) {
            endIndex = this.duplicateResolutionsDataSource.filteredData.length;
        }
        this.duplicateResolutionsSlice = this.duplicateResolutionsDataSource.filteredData.slice(startIndex, endIndex);

        this.updateDuplicateResolutionStudentsDataSource();

        setTimeout(() => {
            const targetElement = this.resElement.nativeElement;
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }

    /****************************************************************************************
          Update Functions
	****************************************************************************************/
    updateDuplicateResolutionType(
        duplicateResolution: DuplicateResolutions,
        duplicateResolutionStudentRegion: DuplicateResolutionStudentRegions,
        duplicateResolutionStudentStatus: DuplicateResolutionStudentStatuses
    ) {
        if (
            duplicateResolution.DUPLICATE_RESOLUTION_TYPES.TYPE !== 'Resolved' &&
            duplicateResolutionStudentRegion.DUPLICATE_RESOLUTION_STUDENT_STATUSES.ID !== duplicateResolutionStudentStatus.ID
        ) {
            let duplicateResolutionStudentStatus_bak = JSON.parse(JSON.stringify(duplicateResolutionStudentRegion.DUPLICATE_RESOLUTION_STUDENT_STATUSES));
            duplicateResolutionStudentRegion.DUPLICATE_RESOLUTION_STUDENT_STATUSES = JSON.parse(JSON.stringify(duplicateResolutionStudentStatus));

            this.studentDeduplicationService.updateDuplicateResolutionType(duplicateResolution.ID, duplicateResolutionStudentRegion).subscribe((res) => {
                if (res.msg) {
                    if (res.msg.SUCCESS) {
                        duplicateResolution.DUPLICATE_RESOLUTION_TYPES = this.duplicateResolutionTypes.find((drt) => drt.TYPE === 'Provisional')!;
                    } else {
                        duplicateResolutionStudentRegion.DUPLICATE_RESOLUTION_STUDENT_STATUSES = JSON.parse(
                            JSON.stringify(duplicateResolutionStudentStatus_bak)
                        );
                    }
                } else {
                    duplicateResolutionStudentRegion.DUPLICATE_RESOLUTION_STUDENT_STATUSES = JSON.parse(JSON.stringify(duplicateResolutionStudentStatus_bak));
                }

                this.updateCanResolve(duplicateResolution);
            });
        }
    }

    updateCanResolve(duplicateResolutions: DuplicateResolutions) {
        let total = 0;
        let same = 0;
        let different = 0;

        duplicateResolutions.DUPLICATE_RESOLUTION_STUDENTS.forEach((drs) => {
            drs.DUPLICATE_RESOLUTION_STUDENT_REGIONS.forEach((drsr) => {
                total++;
                switch (drsr.DUPLICATE_RESOLUTION_STUDENT_STATUSES.STATUS) {
                    case 'Same':
                        same++;
                        break;
                    case 'Different':
                        different++;
                        break;
                    default:
                        break;
                }
            });
        });

        if (same === total) {
            duplicateResolutions.CAN_RESOLVE = 'Same';
        } else if (different === total) {
            duplicateResolutions.CAN_RESOLVE = 'Different';
        } else {
            duplicateResolutions.CAN_RESOLVE = '';
        }
    }

    resolveDuplicateResolutionDifferent(duplicateResolution: DuplicateResolutions) {
        duplicateResolution.RESOLVING = true;

        this.studentDeduplicationService.resolveDuplicateResolutionDifferent(duplicateResolution).subscribe((res) => {
            if (res.msg) {
                if (res.msg.SUCCESS) {
                    duplicateResolution.MSG = res.msg;
                    duplicateResolution.DUPLICATE_RESOLUTION_TYPES.TYPE = 'Resolved';

                    this.studentDeduplicationService.showDuplicateResolution(duplicateResolution.ID).subscribe((res) => {
                        if (res.duplicateResolution) {
                            duplicateResolution = res.duplicateResolution;

                            if (res.sameSsidFound) {
                                Swal.fire({
                                    titleText: 'Resolved - Different (SSID Matching)',
                                    html: "<b>Both SSIDs were removed from both children. Please input each child's correct SSID in their respective child demographics.</b>",
                                    showDenyButton: false,
                                    showConfirmButton: true,
                                    confirmButtonText: 'Continue',
                                    icon: 'warning',
                                    confirmButtonColor: '#3a6b35'
                                }).then((result: any) => {
                                    if (result.isConfirmed) {
                                    }
                                });
                            }
                        }
                    });
                } else {
                    duplicateResolution.MSG = res.msg;
                    duplicateResolution.RESOLVING = false;
                }
            } else {
                duplicateResolution.MSG = new MsgModel();
                duplicateResolution.MSG.SUCCESS = false;
                duplicateResolution.MSG.MSG = 'Failed to resolve students as different. Server error.';
                duplicateResolution.RESOLVING = false;
            }
        });
    }
}
